import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerFailure, updateRegisterForm } from "../redux/userSlice";
import { register } from "../api/userAPI";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

function Register() {
    // STATE/HOOKS =============================================================================================================
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const registerForm = useSelector(state => state.user.registerForm)
    const loading = useSelector(state => state.user.loading)

    // HANDLERS =============================================================================================================
    const validate = () => {
        let valid = true;

        if (registerForm.firstName === "") {
            valid = false;
            dispatch(registerFailure("Must enter a name"))
        } else if (registerForm.username === "") {
            valid = false;
            dispatch(registerFailure("Must enter a username"))
        } else if (registerForm.email === "") {
            valid = false;
            dispatch(registerFailure("Must enter an email"))
        } else if (registerForm.password === "") {
            valid = false;
            dispatch(registerFailure("Must enter a password"))
        } else if (registerForm.password !== registerForm.retype) {
            valid = false;
            dispatch(registerFailure("Passwords do not match"))
        }

        return valid
    }

    const handleRegister = (event) => {
        event.preventDefault();
        if (validate()) {
            dispatch(register({
                name: registerForm.name,
                lastName: registerForm.lastName,
                username: registerForm.username, 
                email: registerForm.email,
                password: registerForm.password,
                navigate: navigate
            }))
        }
    }

    // DOM =============================================================================================================
    return(
        <div className="text-center">
            {loading && <div className="modal">
                <div className="modal-content">
                    <Loader />
                </div>
            </div>}

            <h1>Register</h1>
            <form className="login shadow-lg mobile-w-10-12">
                <h2 className="mb-7">Create a New Account</h2>

                <div>
                    <label htmlFor='name' className=''>full name</label>
                    <input 
                        type="text" 
                        name="name" 
                        id="name" 
                        className='w-11/12' 
                        onChange={(event) => dispatch(updateRegisterForm({field: event.target.name, value: event.target.value}))} 
                        placeholder="Enter Full Name" 
                    />
                </div>

                <div>
                    <label htmlFor='username' className=''>username</label>
                    <input 
                        type="text" 
                        name="username" 
                        id="username" 
                        className='w-11/12' 
                        onChange={(event) => dispatch(updateRegisterForm({field: event.target.name, value: event.target.value}))} 
                        placeholder="Enter Username" 
                    />
                </div>

                <div>
                    <label htmlFor='email' className=''>email</label>
                    <input 
                        type="email" 
                        name="email" 
                        id="email" 
                        className='w-11/12' 
                        onChange={(event) => dispatch(updateRegisterForm({field: event.target.name, value: event.target.value}))} 
                        placeholder="Enter Email" 
                    />
                </div>

                <div>
                    <label htmlFor='password' className=''>password</label>
                    <input 
                        type="password"
                        name="password" 
                        id="password" 
                        className='w-11/12' 
                        placeholder='Enter Password' 
                        onChange={(event) => dispatch(updateRegisterForm({field: event.target.name, value: event.target.value}))}
                    />
                </div>

                <div>
                    <label htmlFor='retype' className=''>re-type password</label>
                    <input 
                        type="password"
                        name="retype" 
                        id="retype" 
                        className='w-11/12' 
                        placeholder='Retype Password' 
                        onChange={(event) => dispatch(updateRegisterForm({field: event.target.name, value: event.target.value}))}
                    />
                </div>

                <p>{registerForm.error}</p>

                <button className="block mx-auto my-3 btn-primary" onClick={(event) => handleRegister(event)}>Submit</button>
            </form>
        </div>
    )
}

export default Register;